
/* What browser?
**********************************************************************/

var isMobile = {
	Android: function() {
		return /android/i.test(navigator.userAgent.toLowerCase());
	},
	BlackBerry: function() {
		return /blackberry/i.test(navigator.userAgent.toLowerCase());
	},
	iOS: function() {
		return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
	},
	Windows: function() {
		return /iemobile/i.test(navigator.userAgent.toLowerCase());
	},
	Opera: function() {
		return /opera mini/i.test(navigator.userAgent.toLowerCase());
	},
	WebOS: function() {
		return /webos/i.test(navigator.userAgent.toLowerCase());
	},
	any: function() {
		return (
			isMobile.Android() || 
			isMobile.BlackBerry() || 
			isMobile.iOS() || 
			isMobile.Windows() || 
			isMobile.Opera() || 
			isMobile.WebOS()
			);
	}
};